import { render, staticRenderFns } from "./CommercialProductProducerList.vue?vue&type=template&id=1580a48c&"
import script from "./CommercialProductProducerList.vue?vue&type=script&lang=js&"
export * from "./CommercialProductProducerList.vue?vue&type=script&lang=js&"
import style0 from "./CommercialProductProducerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports